import DownloadAttachment from './DownloadAttachment';

export default DownloadAttachment;
